import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-list-fragment',
  templateUrl: './user-list-fragment.component.html',
  styleUrls: ['./user-list-fragment.component.css']
})
export class UserListFragmentComponent implements OnInit {
  @Input() users = undefined
  dtOptions: DataTables.Settings = {}
  isLoading = false

  constructor() { }

  ngOnInit(): void {
   this.isLoading = true
    this.dtOptions = {
      pagingType: 'full_numbers'
     };
     this.isLoading=false
    }
}
